export const awsState = {
  loading: false,
  response: null,
  error: false,
};
